export default {
  data() {
    return {
      sexes: [
				{ text: 'Male', value: 1 },
				{ text: 'Female', value: 0 },
			],
			nameExtensions: [
				{ text: '', value: null },
				{ text: 'JR.', value: 'JR.' },
				{ text: 'SR.', value: 'SR.' },
				{ text: 'III', value: 'III' },
				{ text: 'IV', value: 'IV' },
				{ text: 'V', value: 'V' },
			],
			civilStatuses: [
				'Single',
				'Married',
				'Widow/er',
				'Separated',
				'Solo Parent'
			],
			employmentStatuses: [
				'Employed',
				'Unemployed',
			],
			educations: [
				'No Grade Completed',
				'Pre-School (Nursery/ Kinder/ Prep)',
				'Elementary Undergraduate',
				'High School Undergraduate (Old Curriculum)',
				'High School Graduate (Old Curriculum)',
				'K to 12 Undergraduate (New Curriculum)',
				'K to 12 Graduate (New Curriculum)',
				'TechVoc Graduate (Post Secondary)',
				'College Undergraduate',
				'College Graduate or Higher',
      ],
      disabilities: [
        { text: 'None',  value: 0 },
        { text: 'Pregnant', value: 1 },
        { text: 'Other:', value: 2 }
			],
    }
  },
}